module.exports = __webpack_public_path__ + "img/ccl_main0.f8cc4fb6.jpg";